import { Box, Typography } from "@mui/material";
import { ReactNode, useEffect } from "react";
import { Trans } from "react-i18next";
import CopyApiTokenButton from "../../common/OverviewFooter/CopyApiTokenButton";
import styles from "./ConsoleAPILayout.module.scss";

interface Props {
	description?: string;
	hideCopyTokenBtn?: boolean;
	children: ReactNode;
	className?: string;
}

const ConsoleAPILayout = ({ description, hideCopyTokenBtn = false, children, className }: Props) => {
	useEffect(() => {
		if (window.location.hash === "#automotive") {
			const contentDiv = document.getElementById("content");
			if (contentDiv) {
				setTimeout(() => {
					contentDiv.scrollTo({
						top: contentDiv.scrollHeight,
						behavior: "smooth",
					});
				}, 100);
			}
		}
	}, []);

	return (
		<Box className={`${styles.container} ${className || ""}`}>
			<Box className={styles.header}>
				<Trans>
					<Typography className={styles.description}>{description}</Typography>
				</Trans>
				{!hideCopyTokenBtn && <CopyApiTokenButton />}
			</Box>

			<Box className={styles.content} id="content">
				{children}
			</Box>
		</Box>
	);
};

export default ConsoleAPILayout;
